export default "__VITE_ASSET__Ba3jEXd5__"